import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import React from 'react';
import { Tooltip } from './Tooltip.js';
import { jsx } from '@emotion/react';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';
import { LiveRegion } from '../LiveRegion/LiveRegion.js';
import './TippyTooltip.js';
import '@indeed/ifl-css';
import '@tippyjs/react/headless';
import './Arrow.js';
import './plugins.js';
import '../../utils/transition.js';
import '../../utils/warnDeprecation.js';
import '../../utils/warn.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import './PopupTooltip.js';
import '../../index-26fc6478.js';
import '../../utils/mergeRefs.js';
import 'use-debounce';
import '@indeed/ihl-use-id';
import '../Popup/Popup.js';
import '@floating-ui/react-dom';
import '../../hooks/useMergeRefs.js';
import '../Box/Box.js';
import '../Portal/Portal.js';
import 'react-dom';

const ToggleTooltip = _ref => {
  let {
    label,
    onHide = () => {},
    onShow = () => {},
    ...props
  } = _ref;
  const [visible, setVisible] = React.useState(false);
  return jsx(React.Fragment, null, jsx(Tooltip, _extends({
    aria: {
      content: null,
      expanded: true
    },
    label: label,
    onHide: () => (onHide() ?? true) && setVisible(false),
    onShow: () => (onShow() ?? true) && setVisible(true),
    popupProps: {
      "aria-hidden": true,
      tabIndex: -1
    },
    trigger: "click touch"
  }, props)), visible ? jsx(VisuallyHidden, null, jsx(LiveRegion, null, jsx("span", null, label))) : null);
};

export { ToggleTooltip };
